import React from "react";
import Link from "gatsby-link";
import { Container, Row, Col, Visible, Hidden, ScreenClassRender } from 'react-grid-system';
import "./Toplist.css";

class Toplist extends React.Component {
  render() {
    return (
      <Container>
      <Row>
        <h2>Laina-avun poiminnat</h2>
        <p>Laina-apu listaa vain luotettavia toimijoita ja lisää uusia lainanantajia tarkkaan seulomalla. Klikkaamalla kuvaa pääset tutustumaan tarkemmin kyseiseen toimijaan.</p>
        <Row>
            <Col lg={3}>
              <a href="/arkadia-rahoitus-lainaa-500-50-000-euroa"><img className="toplist-img" src="/img/arkadiarahoitus-lainaa-logo.jpg" /></a>
            </Col>
            <Col lg={3}>
            <h3 className="toplist-title">Arkadirahoitus</h3>
            <ul className="toplist"><li>Kulutusluotto</li>
            <li>500 - 50 000 euroa</li></ul>
            <a className="btn" href="/mene/arkadiarahoitus.html" target="_blank" rel="nofollow">Hae lainaa</a>
            </Col>
            <Col lg={3}>
              <a href="/luotto-raha-hae-heti-2000-€-lainaa"><img className="toplist-img" src="/img/luottoraha-lainaa-logo.jpg" /></a>
            </Col>
            <Col lg={3}>
            <h3 className="toplist-title">Luottoraha</h3>
            <ul className="toplist"><li>Joustava kulutusluottoa</li>
            <li>2000€ jatkuva luotto</li></ul>
            <a className="btn" href="/mene/luottoraha.html" target="_blank" rel="nofollow">Hae lainaa</a>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <a href="ok-money-hae-heti-lainaa"><img className="toplist-img" src="/img/okmoney-lainaa-logo.jpg" /></a>
            </Col>
            <Col lg={3}>
            <h3 className="toplist-title">OK Money</h3>
            <ul className="toplist"><li>Kulutusluotto</li>
            <li>2 100 €</li></ul>
            <a className="btn" href="/mene/okmoney.html" target="_blank" rel="nofollow">Hae lainaa</a>
            </Col>
            <Col lg={3}>
              <a href="lainasto"><img className="toplist-img" src="/img/lainasto-lainaa.jpg" /></a>
            </Col>
            <Col lg={3}>
            <h3 className="toplist-title">Lainasto.fi</h3>
            <ul className="toplist"><li>Pikalaina</li>
            <li>Lainaa 100 - 3 000 euroa</li></ul>
            <a className="btn" href="/mene/lainasto.html" target="_blank" rel="nofollow">Hae lainaa</a>
            </Col>
        </Row>
      </Row>
      </Container>
    );
  }
}

export default Toplist;



// WEBPACK FOOTER //
// ./src/components/Toplist/Toplist.jsx